import React, {forwardRef} from 'react'
import PropTypes from 'prop-types'
import Close from '#components/svg/icons/Close'
import Delete from '#components/svg/icons/Delete'
import Mail from '#components/svg/icons/Mail'
import Notice from '#components/svg/icons/Notice'
import BoldText from '#components/svg/icons/BoldText'
import UnderlineText from '#components/svg/icons/UnderlineText'
import ColorText from '#components/svg/icons/ColorText'
import Hide from '#components/svg/icons/Hide'
import Copy from '#components/svg/icons/Copy'
import RemoveAusbilder from '#components/svg/icons/RemoveAusbilder'
import Download from '#components/svg/icons/Download'
import Emoji from '#components/svg/icons/Emoji'
import Heart from '#components/svg/icons/Heart'
import ThumbsUp from '#components/svg/icons/ThumbsUp'
import StylizedEmoji from '#components/svg/icons/StylizedEmoji'

const IconButton = forwardRef((props, ref) => {
  let svg
  switch (props.icon) {
    case 'close':
      svg = <Close />
      break
    case 'delete':
      svg = <Delete />
      break
    case 'mail':
      svg = <Mail />
      break
    case 'boldText':
      svg = <BoldText />
      break
    case 'underlineText':
      svg = <UnderlineText />
      break
    case 'colorText':
      svg = <ColorText />
      break
    case 'notice':
      svg = <Notice />
      break
    case 'hide':
      svg = <Hide />
      break
    case 'copy':
      svg = <Copy />
      break
    case 'removeAusbilder':
      svg = <RemoveAusbilder />
      break
    case 'download':
      svg = <Download />
      break
    case 'emoji':
      svg = <Emoji />
      break
    case 'heart':
      svg = <Heart />
      break
    case 'thumbsUp':
      svg = <ThumbsUp />
      break
    case 'stylizedEmoji':
      svg = <StylizedEmoji />
      break
    default:
      break
  }

  return (
    <button
      data-testid={`button--${props.icon}`}
      type="button"
      className="iconbutton"
      onClick={props.event}
      onMouseDown={props.onMouseDown}
      ref={ref}>
      {svg}
    </button>
  )
})

IconButton.propTypes = {
  event: PropTypes.func,
  onMouseDown: PropTypes.func,
  icon: PropTypes.string,
}

export default IconButton
